export const  PRODUCT_LIST_REQUEST = "PRODUCT_LIST_REQUEST"
export const  PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS"
export const  PRODUCT_LIST_FAIL = "PRODUCT_LIST_FAIL"


export const  PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST"
export const  PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS"
export const  PRODUCT_DETAILS_FAIL = "PRODUCT_DETAILS_FAIL"

export const PRODUCT_REVIEW_CREATE_REQUEST = 'PRODUCT_REVIEW_CREATE_REQUEST';
export const PRODUCT_REVIEW_CREATE_SUCCESS = 'PRODUCT_REVIEW_CREATE_SUCCESS';
export const PRODUCT_REVIEW_CREATE_FAIL = 'PRODUCT_REVIEW_CREATE_FAIL';
export const PRODUCT_REVIEW_CREATE_RESET = 'PRODUCT_REVIEW_CREATE_RESET';